import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Question } from '../lib/types';
import atNodeDB from '../lib/database';

export default function Questions({ dataChanged }: { dataChanged: number }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedQuestions, setSelectedQuestions] = useState<Question[]>([]);
  const [availableQuestions, setAvailableQuestions] = useState<Question[]>([]);
  const [showPager, setShowPager] = useState<boolean>(false);

  useEffect(() => {
    const loadQuestions = async () => {
      const keywords: number[] = searchParams.get('selectedKeywords')?.split(',').map(Number) || [];
      const [loadedQuestions, thereIsMore] = await atNodeDB.loadQuestions(keywords, searchParams.get('searchQuestions') || '', 14);
      const newAvailableQuestions = loadedQuestions.filter((question) => !selectedQuestions.some((selected) => selected.Id === question.Id));
      setAvailableQuestions(newAvailableQuestions);
      setShowPager(thereIsMore);
    };
    loadQuestions();
  }, [searchParams, selectedQuestions, dataChanged]);

  async function removeSelectedQuestion(question: Question) {
    const newSelectedQuestions = selectedQuestions.filter(
      (questionItem) => questionItem !== question
    );
    setSelectedQuestions(newSelectedQuestions);
    setAvailableQuestions([question, ...availableQuestions]);

    const params = new URLSearchParams(searchParams);
    if (newSelectedQuestions.length > 0) {
      params.set(
        'selectedQuestions',
        newSelectedQuestions.map((questionItem) => questionItem.Id).join(',')
      );
    } else {
      params.delete('selectedQuestions');
    }
    setSearchParams(params);
  }

  async function addSelectedQuestion(question: Question) {
    const newSlectedQuestions = [question, ...selectedQuestions];
    setSelectedQuestions(newSlectedQuestions);
    setAvailableQuestions(
      availableQuestions.filter(
        (questionItem) => questionItem.Id !== question.Id
      )
    );

    const params = new URLSearchParams(searchParams);
    params.set(
      'selectedQuestions',
      newSlectedQuestions.map((questionItem) => questionItem.Id).join(',')
    );
    setSearchParams(params);
  }

  async function searchQuestions(search: string) {
    const params = new URLSearchParams(searchParams);
    if (search) {
      params.set('searchQuestions', search);
    } else {
      params.delete('searchQuestions');
    }
    setSearchParams(params);
  }

  return (
    <div className='box'>
      <div className='search-box'>
        <input
          type="text"
          onFocus={(e) => e.target.select()}
          onChange={async (e) => searchQuestions(e.target.value)}
          placeholder="Search questions"
          className="input-search"
        />
      </div>
      <div className="items-box">
        {selectedQuestions.length > 0 && (<div className='items-selected'>
          {selectedQuestions.map((question) => {
            return (
              <button
                type="button"
                key={`question${question.Id}`}
                onClick={async () => removeSelectedQuestion(question)}
                className="btn-question-selected"
              >
                {question.Name}
              </button>
            );
          })}
        </div>)}
        <div className='items'>
          {availableQuestions.map((question) => {
            return (
              <button
                type="button"
                key={`availableQuestion${question.Id}`}
                onClick={async () => addSelectedQuestion(question)}
                className="btn-question"
              >
                {question.Name}
              </button>
            );
          })}
        </div>
        {showPager && (
          <div className="pager">
            ...more
          </div>
        )}
      </div>
    </div>
  );
}
